import React from 'react';
import { Helmet } from 'react-helmet';
import Orders from '../components/Order';

const OrderPage = () => {
  return (
    <>
      <Helmet>
        <title>Orders</title>
      </Helmet>
      <Orders />
    </>
  );
};

export default OrderPage;
